import { useSelector } from 'react-redux';
import { Col, Row } from 'antd';

import { BaseModalProps } from 'global/Modal/BaseModal';
import { TargetShareItem } from 'typings/api/shareTradeShare';
import ShareTradeAttachment from 'features/chat/MainContent/BubbleChat/ShareTradeAttachment';
import { selectors as profileSelectors } from 'lib/entities/profile';
import { ShareTradeInfo } from 'typings/api/shareTradeChat';
import { SubmitButton } from 'features/sharetrade/components/ModalShareTrade/styled';
import { UpdateSettingTargetItem } from 'typings/api/shareTradeSetting';

import UserItem from './UserItem';
import {
  Modal,
  FooterCol,
  HeaderRow,
  ContentRow,
  ContentCard,
  CardHeader,
  CardLists,
} from './styled';

interface ModalShareConfirmProps extends BaseModalProps {
  selectedUsers: UpdateSettingTargetItem[];
  previewShareTrade: ShareTradeInfo | Record<string, never>;
  isLoading: boolean;
  filterSelected?: boolean;
  onConfirm(): void;
  onSwitchChange(checked: boolean, user: TargetShareItem): void;
}

export default function ModalShareConfirm({
  title = 'Review Share Trade',
  width = 430,
  selectedUsers,
  previewShareTrade,
  isLoading,
  filterSelected = false,
  onConfirm = () => { },
  onSwitchChange = () => { },
  onCancel,
  ...props
}: ModalShareConfirmProps) {
  const { data: profile } = useSelector(profileSelectors);

  const isEmptyUsers =
    filterSelected &&
    selectedUsers?.filter(({ is_selected }) => is_selected)?.length === 0;

  return (
    <Modal title={title} width={width} onCancel={onCancel} {...props}>
      <HeaderRow>
        <span>Your Investment amount will be shared to these contact(s)</span>
      </HeaderRow>
      <ContentRow>
        <ContentCard>
          <CardHeader>
            <ShareTradeAttachment
              info={previewShareTrade}
              username={profile.username}
              isVerified={false}
              usernameColor="#94B041"
              hidePreviousOrder={false}
              hideUsername={false}
              onPreviousOrderClick={() => { }}
              isPreview
            />
          </CardHeader>

          {!isEmptyUsers && (
            <CardLists>
              {selectedUsers?.map((user) => (
                <UserItem
                  key={user.id}
                  avatarUrl={user.avatar_url}
                  name={user.name}
                  alias={user.shortened_name}
                  targetType={user.type}
                  description={user.description}
                  isVerified={user.is_verified}
                  defaultSwitchValue={user.is_share_value || false}
                  onSwitchChange={(checked) => onSwitchChange(checked, user)}
                />
              ))}
            </CardLists>
          )}
        </ContentCard>
      </ContentRow>
      <FooterCol span={24}>
        <Row align="middle">
          <Col span={24}>
            <SubmitButton
              type="primary"
              onClick={onConfirm}
              loading={isLoading}
              disabled={isLoading}
              block
            >
              Confirm
            </SubmitButton>
          </Col>
        </Row>
      </FooterCol>
    </Modal>
  );
}
